import { useRef } from 'react';
import React from 'react'
import { useState } from 'react'
import DownloadDivWork from '../../Download/DownloadDiv';
const random = (min, max) => {
    return (Math.floor(Math.random()
        * (max - min + 1)) + min);
}
const GenDiv = () => {

    const getswitch = (digit1) => {

        switch (digit1) {
            case '1':
                return random(1, 9)
                break;
            case '2':
                return random(10, 99)
                break;
            case '3':
                return random(100, 999)
                break;
            case '4':
                return random(1000, 9999)
                break;
            default:
                break;
        }
    }
    const [digit1, setdigit1] = React.useState();
    const [digit2, setdigit2] = React.useState();
    const [ques, setques] = React.useState();
    const [file, setfile] = React.useState();
    const [ansDownload, setansDownload] = React.useState(1);
    const [Reminder, setReminder] = React.useState(0);
    const [ParticularNumber, setParticularNumber] = React.useState(0);
    const [down, setdown] = React.useState(0);
    const [btn, setbtn] = React.useState(0);
    const [ch, setch] = React.useState("");
    const [mat, setmat] = useState([])
    const [refrsh, setrefrsh] = useState(0)


    const getmat = (ques, digit1, digit2) => {
        let temp = []
        let dividend;
        let divisor
        if (Reminder) {
            for (let i = 0; i < ques; i++) {
                let ele1;
                let ele2;
                do {
                    ele1 = getswitch(digit1)
                    ele2 = getswitch(digit2)
                } while (ele1 % ele2 == 0 || ele1 % ele2 == 1)
                temp.push(ele1)
                temp.push(ele2)
                mat.push(temp)
                temp = []
            }

        } else {
            for (let i = 0; i < ques; i++) {
                do {
                    dividend = getswitch(digit1)
                    divisor = getswitch(digit2)
                } while (dividend % divisor !== 0 || dividend == divisor || dividend == 1 || divisor == 1)
                temp.push(dividend)
                temp.push(divisor)
                mat.push(temp)
                temp = []
            }

        }
    }
      function Xbtn(event) {
    setbtn(0)
    // window.location.reload()    
  }
    function cal(event) {
        event.preventDefault();
        if (refrsh) {
            window.location.reload()
        }
        if (digit1 < digit2) {
            alert("divisor lesser than dividend!")
            window.location.reload()
            return 0;
        }
        getmat(ques, digit1, digit2)
        if (mat.length != 0) {
            let row = 2;
            setch("d")
            console.log(mat)
            setbtn(1)
        }

    }

    let props = {
        ques: ques,
        mat: mat,
        file: file,
        digit1: digit1,
        digit2: digit2,
        ch: ch,
        Reminder: Reminder,
        ansDownload: ansDownload

    }

    const targetRef = useRef();

    return (
        <div className='bg'>
            <div className='main'>
                <form onSubmit={cal} className='main-form'>
          <h2 className='form-name'><span className='underline'>Divsion</span> (Genrate)</h2>
                    {/* <h2 className='form-name'>Divsion</h2> */}
                    <label htmlFor="digit">Number of Digit ÷ Digit</label>
                    <div className='mul_dig'>
                        <input type="number" max="4" name="name" className='input-fld box' id="digit" placeholder="2" onChange={(e) => { setdigit1(e.target.value) }} required />
                        <h3>÷</h3>
                        <input type="number" name="email" id="row" placeholder="1" className='input-fld box' required onChange={(e) => { setdigit2(e.target.value) }} />
                    </div>
                    <div className='check'>
                        <label htmlFor="zig">Reminder  -- </label>
                        <input type="checkbox" name="zig-zag" id="zig-zag" onClick={() => { return Reminder ? setReminder(false) : setReminder(true) }} />
                        {/* {Particular ? <input type="number" name="particular" className='input-fld' id="particular" onChange={(e) => { setParticularNumber(e.target.value) }} /> : ""} */}
                    </div>
                    <label htmlFor='ques'>No Of Questions</label>
                    <input type="number" className='box' name="ques" id="ques" placeholder="10" max={100} required onChange={(e) => { setques(e.target.value) }} />
                    <label htmlFor='ques'>File name</label>
                    <input type="text" name="file" id="file" className='box' placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />

                    <div className='submit'>
                        <input type="submit" id='reset' className='bt-purple' value="Finish" />
                        <input type="reset" id='reset' className='bt-purple' value="Refresh" onClick={() => { window.location.reload() }} />
                    </div>
                </form>
            </div>

            <div className={btn ? "popUp-download" : "hide-popUp-download"}>
                <button className='X-btn' onClick={() => { Xbtn() }}>X</button>
                <div className='download-ques-btn'>
                    <DownloadDivWork  {...{ mat, ques, file, ch, ParticularNumber }} />
                    <DownloadDivWork  {...{ mat, ques, file, ch, ansDownload, Reminder }} />
                </div>
            </div>
        </div>
    )
}
export default GenDiv

